import { RouteRecordRaw } from 'vue-router';
import type { Component } from 'vue';

// 動的インポート関数 - Vue Component型を使用
const Index = (): Promise<Component> => import('@/pages/candidate/IndexPage.vue');
const About = (): Promise<Component> => import('@/pages/candidate/AboutPage.vue');
const Login = (): Promise<Component> => import('@/pages/candidate/LoginPage.vue');
const ForgotPassword = (): Promise<Component> => import('@/pages/candidate/ForgotPassword.vue');
const ResetPassword = (): Promise<Component> => import('@/pages/candidate/ResetPassword.vue');
const CompletedResetPassword = (): Promise<Component> =>
  import('@/pages/candidate/CompletedResetPassword.vue');
const FinalEducation = (): Promise<Component> => import('@/pages/candidate/Education.vue');
const ExperienceCompany = (): Promise<Component> =>
  import('@/pages/candidate/ExperienceCompany.vue');
const CompletedBasicInfo = (): Promise<Component> =>
  import('@/pages/candidate/CompletedBasicInfo.vue');
const EditProfile = (): Promise<Component> => import('@/pages/candidate/EditProfile.vue');

// 新しいステップのインポート
const CareerStep = (): Promise<Component> => import('@/pages/candidate/CareerStep.vue');
const WorkHistoryStep = (): Promise<Component> => import('@/pages/candidate/WorkHistoryStep.vue');
const DesiredConditionsStep = (): Promise<Component> =>
  import('@/pages/candidate/DesiredConditionsStep.vue');
const SkillsStep = (): Promise<Component> => import('@/pages/candidate/SkillsStep.vue');
const BasicInfoStep = (): Promise<Component> => import('@/pages/candidate/BasicInfoStep.vue');
const ResumeEducationStep = (): Promise<Component> =>
  import('@/pages/candidate/ResumeEducationStep.vue');
const AdditionalInfoStep = (): Promise<Component> =>
  import('@/pages/candidate/AdditionalInfoStep.vue');

const Completed = (): Promise<Component> => import('@/pages/candidate/Completed.vue');
const RegisterComplete = (): Promise<Component> =>
  import('@/pages/candidate/CompleteRegisterEmail.vue');
const ForgotPasswordComplete = (): Promise<Component> =>
  import('@/pages/candidate/CompleteForgotPassword.vue');
const VerifyPage = (): Promise<Component> => import('@/pages/candidate/VerifyPage.vue');
const VerifyResetPasswordPage = (): Promise<Component> =>
  import('@/pages/candidate/VerifyResetPasswordPage.vue');
const OfferReport = (): Promise<Component> =>
  import('@/pages/candidate/offer_report/OfferReport.vue');
const CompletedOfferReport = (): Promise<Component> =>
  import('@/pages/candidate/offer_report/Completed.vue');
const JobSearch = (): Promise<Component> => import('@/pages/candidate/JobSearch.vue');
const FAQ = (): Promise<Component> => import('@/pages/candidate/FAQPage.vue');
const TermAndCondition = (): Promise<Component> =>
  import('@/pages/candidate/TermAndConditionPage.vue');
const PrivacyPolicy = (): Promise<Component> => import('@/pages/candidate/PrivacyPolicyPage.vue');
const NotFoundPage = (): Promise<Component> => import('@/pages/candidate/NotFoundPage.vue');
const BasicInformationUpdatePassword = (): Promise<Component> =>
  import('@/pages/candidate/register/basic_information/UpdatePassword.vue');
const JobDirection = (): Promise<Component> => import('@/pages/candidate/job/JobDirection.vue');
const SignUpDirection = (): Promise<Component> =>
  import('@/pages/candidate/register/basic_information/SignUpDirection.vue');
const CpContact = (): Promise<Component> => import('@/pages/candidate/CpContact.vue');
const CpContactDone = (): Promise<Component> => import('@/pages/candidate/CpContactDone.vue');
const Contact = (): Promise<Component> => import('@/pages/candidate/Contact.vue');
const ContactDone = (): Promise<Component> => import('@/pages/candidate/ContactDone.vue');
const TeaserThanks = (): Promise<Component> => import('@/pages/teaser/thanks.vue');
const Partners = (): Promise<Component> => import('@/pages/partners.vue');
const Business = (): Promise<Component> => import('@/pages/business.vue');

const routes: Array<RouteRecordRaw> = [
  {
    path: '/signup/new',
    components: {
      default: SignUpDirection,
    },
  },
  {
    path: '/candidate/signup/update_password',
    components: {
      default: BasicInformationUpdatePassword,
    },
  },
  {
    path: '/candidate/about',
    name: 'about',
    components: {
      default: About,
    },
  },
  {
    path: '/candidate/login',
    name: 'login',
    components: {
      default: Login,
    },
  },
  {
    path: '/candidate/forgot_password',
    name: 'forgot_password',
    components: {
      default: ForgotPassword,
    },
  },
  {
    path: '/candidate/reset_password',
    name: 'reset_password',
    components: {
      default: ResetPassword,
    },
  },
  {
    path: '/candidate/reset_password/completed',
    name: 'reset_password_completed',
    components: {
      default: CompletedResetPassword,
    },
  },
  {
    path: '/candidate/job_search',
    name: 'job-search',
    components: {
      default: JobSearch,
    },
  },
  // 新しいステップのルート
  {
    path: '/candidate/career',
    name: 'career',
    components: {
      default: CareerStep,
    },
  },
  {
    path: '/candidate/work_history',
    name: 'work_history',
    components: {
      default: WorkHistoryStep,
    },
  },
  {
    path: '/candidate/desired_condition',
    name: 'desired_condition',
    components: {
      default: DesiredConditionsStep,
    },
  },
  {
    path: '/candidate/resume_skills',
    name: 'resume_skills',
    components: {
      default: SkillsStep,
    },
  },
  {
    path: '/candidate/basic_info',
    name: 'basic_info',
    components: {
      default: BasicInfoStep,
    },
  },
  {
    path: '/candidate/resume_education',
    name: 'resume_education',
    components: {
      default: ResumeEducationStep,
    },
  },
  {
    path: '/candidate/additional_info',
    name: 'additional_info',
    components: {
      default: AdditionalInfoStep,
    },
  },
  {
    path: '/candidate/education',
    name: 'education',
    components: {
      default: FinalEducation,
    },
  },
  {
    path: '/candidate/experience',
    name: 'experience',
    components: {
      default: ExperienceCompany,
    },
  },
  {
    path: '/candidate/completed_information',
    name: 'completed_information',
    components: {
      default: CompletedBasicInfo,
    },
  },
  {
    path: '/candidate/completed',
    name: 'completed',
    components: {
      default: Completed,
    },
  },
  {
    path: '/teaser/thanks',
    name: 'teaser_thanks',
    components: {
      default: TeaserThanks,
    },
  },
  {
    path: '/candidate/register_complete',
    name: 'register_complete',
    components: {
      default: RegisterComplete,
    },
  },
  {
    path: '/candidate/forgot_password_complete/:email',
    name: 'forgot_password_complete',
    components: {
      default: ForgotPasswordComplete,
    },
    props: true,
  },
  {
    path: '/profiles/edit',
    name: 'edit_profile',
    components: {
      default: EditProfile,
    },
  },
  {
    path: '/candidate/verify',
    name: 'verify',
    components: {
      default: VerifyPage,
    },
  },
  {
    path: '/candidate/verify_reset_password',
    name: 'verify_reset_password',
    components: {
      default: VerifyResetPasswordPage,
    },
  },
  {
    path: '/profiles/offer_report',
    name: 'offer_report',
    components: {
      default: OfferReport,
    },
  },
  {
    path: '/profiles/offer_report/fin',
    name: 'completed_offer_report',
    components: {
      default: CompletedOfferReport,
    },
  },
  {
    path: '/faq',
    name: 'faq',
    components: {
      default: FAQ,
    },
  },
  {
    path: '/terms',
    name: 'terms',
    components: {
      default: TermAndCondition,
    },
  },
  {
    path: '/privacy',
    name: 'privacy',
    components: {
      default: PrivacyPolicy,
    },
  },
  {
    path: '/partners',
    name: 'Partners',
    component: Partners,
  },
  {
    path: '/business',
    name: 'business',
    component: Business,
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not_found',
    components: {
      default: NotFoundPage,
    },
  },
  {
    path: '/jobs',
    name: 'jobs_direction',
    components: {
      default: JobDirection,
    },
  },
  {
    path: '/cp-contact',
    name: 'cp_contact',
    components: {
      default: CpContact,
    },
  },
  {
    path: '/cp-contact/done',
    name: 'cp_contact_done',
    components: {
      default: CpContactDone,
    },
  },
  {
    path: '/contact',
    name: 'contact',
    components: {
      default: Contact,
    },
  },
  {
    path: '/contact/done',
    name: 'contact_done',
    components: {
      default: ContactDone,
    },
  },
];

export default routes;
